import { props } from '@ngrx/store';
import { createActionGroup, emptyProps } from '@ngrx/store';

import { Course } from '../models';

export const courseActions = createActionGroup({
    source: 'Content Courses',
    events: {
        'Get Course': props<{ id: string }>(),
        'Get Course Success': props<{ course: Course }>(),
        'Get Course Error': props<{ id: string }>(),
        Clear: emptyProps(),
    },
});
